<template>
  <div class="row justify-content-center">
    <div class="col-md-4 col-sm-8 mt-5">
      <div class="card shadow-sm">
        <div class="card-header bg-light">
          <h4 class="card-title m-0 text-center">
            <i class="fas fa-lock me-2 text-primary"></i>Change Password
          </h4>
        </div>
        <div class="card-body">
          <div class="text-muted text-center mb-4">
            <i class="fas fa-info-circle me-1"></i>
            First time login. Change of password required.
          </div>
          <form @submit.prevent="updateSubmit">
            <div class="mb-3">
              <label class="form-label fw-bold">New Password</label>
              <div class="input-group">
                <span class="input-group-text bg-white">
                  <i class="fas fa-key text-primary"></i>
                </span>
                <input
                  type="password"
                  class="form-control border-start-0"
                  placeholder="Enter new password"
                  v-model="user.password"
                >
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label fw-bold">Confirm Password</label>
              <div class="input-group">
                <span class="input-group-text bg-white">
                  <i class="fas fa-check-circle text-primary"></i>
                </span>
                <input
                  type="password"
                  class="form-control border-start-0"
                  placeholder="Confirm your password"
                  v-model="user.password_confirmation"
                >
              </div>
            </div>
            <hr class="border-1 border-info border-opacity-75 mt-4" />
            <div class="mt-4 d-flex flex-row justify-content-between align-items-center">
              <button class="btn btn-outline-secondary" @click="$router.push('/login')">
                <i class="fas fa-times me-1"></i> Cancel
              </button>
              <button class="btn btn-primary" @click="updateSubmit">
                <i class="fas fa-save me-1"></i> Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import userService from "@/api/userService";
import {decrypt} from "@/utils/crypto";
export default {
  name: 'Login',
  data() {
    return {
      user: {
        password: '',
        password_confirmation: '',
      },
    }
  },
  methods: {
    async updateSubmit() {
      let profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
      await userService.changePassword(this.user, profile.id)
    },
  }
}
</script>
